/* Kevora helpers: header scroll state and height, hero slider, arrow-scrolled rails. No dependencies. */
(function () {
  function headerState() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    h.classList.toggle('tr-header-solid', y > 10);
  }
  function headerHeight() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    document.documentElement.style.setProperty('--tr-hdr', h.offsetHeight + 'px');
  }
  var ro = null;
  function headerInit() {
    headerState();
    headerHeight();
    var h = document.querySelector('.section-header');
    if (h && 'ResizeObserver' in window) {
      if (ro) ro.disconnect();
      ro = new ResizeObserver(headerHeight);
      ro.observe(h);
    }
  }
  window.addEventListener('scroll', headerState, { passive: true });
  window.addEventListener('resize', headerHeight);
  window.addEventListener('load', headerHeight);
  window.addEventListener('pageshow', headerInit);
  document.addEventListener('shopify:section:load', headerInit);
  headerInit();

  function heroGo(hero, n) {
    var slides = hero.querySelectorAll('[data-tr-slide]');
    if (!slides.length) return;
    var i = (n + slides.length) % slides.length;
    hero._tri = i;
    slides.forEach(function (s, k) {
      s.classList.toggle('is-active', k === i);
      s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
    hero.querySelectorAll('[data-tr-dot]').forEach(function (d, k) {
      d.classList.toggle('is-active', k === i);
    });
  }
  function heroInit(hero) {
    if (hero._trInit) return;
    hero._trInit = true;
    hero._tri = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = parseInt(hero.getAttribute('data-speed'), 10) || 6000;
    if (hero.getAttribute('data-autoplay') === 'true' && !reduce) {
      hero._trTimer = setInterval(function () {
        if (!document.hidden && !hero.matches(':hover')) heroGo(hero, hero._tri + 1);
      }, speed);
    }
  }
  function initAll() {
    document.querySelectorAll('[data-tr-hero]').forEach(heroInit);
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-tr-dot]');
    if (dot) {
      var h = dot.closest('[data-tr-hero]');
      if (h) heroGo(h, parseInt(dot.getAttribute('data-index'), 10) || 0);
      return;
    }
    var btn = e.target.closest('[data-tr-prev],[data-tr-next]');
    if (!btn) return;
    var dir = btn.hasAttribute('data-tr-next') ? 1 : -1;
    var hero = btn.closest('[data-tr-hero]');
    if (hero) { heroGo(hero, (hero._tri || 0) + dir); return; }
    var root = btn.closest('[data-tr-scroller]');
    var track = root && root.querySelector('[data-tr-track]');
    if (!track || !track.firstElementChild) return;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = track.firstElementChild.getBoundingClientRect().width + gap;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-tr-hero]');
    if (!hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-tr-slide]'));
    var idx = slides.indexOf(e.target);
    if (idx > -1) heroGo(hero, idx);
  });
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();